import { Injectable } from "@angular/core";
import {
  HttpRequest,
  HttpHandler,
  HttpEvent,
  HttpInterceptor,
  HttpResponse,
  HttpErrorResponse,
} from "@angular/common/http";
import { Observable, throwError } from "rxjs";
import { tap, catchError } from "rxjs/operators";
import { Router } from "@angular/router";
import * as moment from "moment-timezone";

@Injectable()
export class AuthInterceptor implements HttpInterceptor {
  constructor(private _router: Router) {}

  intercept(
    req: HttpRequest<any>,
    next: HttpHandler
  ): Observable<HttpEvent<any>> {
    const isPublicRequest =
      req.url.includes("Account/Login") ||
      req.url.includes("Account/RefreshToke") ||
      req.url.includes("AppVersion/GetAppLatestVersion");

    if (isPublicRequest) {
      return next.handle(req);
    }

    const userTimeZone = moment.tz.guess();
    let headers: { [key: string]: string } = {};
    try {
      const selectedCompanyBranch = JSON.parse(localStorage.getItem("selectedCompanyBranch") || "null");
      const selectedUserObj = JSON.parse(localStorage.getItem("user") || "null");
      const token = localStorage.getItem("token");
      const branchTimeZoneName = typeof selectedCompanyBranch?.timeZoneName === "string"
        ? selectedCompanyBranch.timeZoneName.trim()
        : "";
      const timeZoneId = Number(selectedCompanyBranch?.timeZoneId);
      const isS3Request = req.url.includes("dehlawi-asset.s3.ap-south-1.amazonaws.com");

      if (
        !token ||
        !selectedUserObj?.userId ||
        !selectedCompanyBranch?.companyId ||
        !selectedCompanyBranch?.companyBranchId ||
        !branchTimeZoneName ||
        !Number.isFinite(timeZoneId) ||
        timeZoneId <= 0
      ) {
        if (!window.location.pathname.includes("/authentication/login")) {
          this._router.navigate(["/authentication/login"]);
        }
        return throwError(() => new Error("Session data is missing. Please log in again."));
      }

      headers = {
        CompanyId: selectedCompanyBranch.companyId.toString(),
        CompanyBranchId: selectedCompanyBranch.companyBranchId.toString(),
        UserId: selectedUserObj.userId.toString(),
        UserDateTime: new Date().toString(),
        UserTimeZone: userTimeZone.toString(),
        TimeZoneName: branchTimeZoneName,
        timeZoneId: timeZoneId.toString(),
      };

      if (!isS3Request) {
        headers["Authorization"] = token;
      }
    } catch (error) {
      console.error("Error parsing local storage items", error);
      return throwError(() => error);
    }

    req = req.clone({
      setHeaders: headers,
    });

    return next.handle(req).pipe(
      tap((evt) => {
        if (evt instanceof HttpResponse) {
          return evt;
        }
      }),
      catchError((error) => {
        if (error instanceof HttpErrorResponse) {
          //to handle errors
          //console.error('error status = ', error.status);
          // console.log('---> filter:', req.params.get('filter'));

          if (error.status >= 300 && error.status !== 404) {
            // redirect to error page
            // OR you can use a toast
            // console.error('redirect');
            // this.router.navigate(['http-error'], { queryParams: { status: error.status } });
          }
          console.log("Here is Error in INTERCEPTOR", error);
        }
        return throwError(() => error);
      })
    );
  }
}
